import httpClient from "./httpClient";
interface HttpResponse {
  code: number;
  data: any;
}

export const getPrices = (): Promise<HttpResponse> => {
  return httpClient.get("/prices") as Promise<HttpResponse>;
};
